 import React from 'react';
 import './home.css'
 //import { Link } from "react-router-dom";
 import Header from "../header/Header"

 const Home = () => {
    return (
      <div className="home">
       
      
      <Header />

      </div>
    );
 }
  
 export default Home;